export const styles = {};
